/* global axios */
import ApiClient from './ApiClient';

class ProductPlanAPI extends ApiClient {
  constructor() {
    super('product_plans', { accountScoped: true });
  }

  get({ productId } = {}) {
    const query = productId ? `?product_id=${productId}` : '';
    return axios.get(`${this.url}${query}`);
  }
}

export default new ProductPlanAPI();
